import { render } from "./FlagEnglish.vue?vue&type=template&id=85bf61d0&ts=true"
import script from "./FlagEnglish.vue?vue&type=script&lang=ts"
export * from "./FlagEnglish.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/paul/Documents/JetBrains/PhpstormProjects/AzuriomInstaller/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__